<p-dialog [(visible)]="visibleModalQRProcess" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="subtitle mb-15">
          <h2>Pasos a seguir:</h2>
        </div>
        <div class="stepBox">
          <div class="text smallList">
            <ul>
              <li>
                <div class="stepNumber"><span>1</span></div>
                <p>Inicia la configuración del equipo.</p>
              </li>
              <li>
                <div class="stepNumber"><span>2</span></div>
                <p>Al finalizar, debe llegar una notificación indicando “Financiamiento de Equipo”.</p>
              </li>
              <li>
                <div class="stepNumber"><span>3</span></div>
                <p>En ese momento, presiona “Continuar”, lo cual debe permitir avanzar con la gestión.</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="dialog__btn dialog__block">
          <button pButton pRipple label="Continuar el proceso" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="visibleModalEndProcess=true; visibleModalQRProcess=false"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<p-dialog [(visible)]="visibleModalEndProcess" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>¿Realizaste todo el proceso completo?</h2>
          <p>Puedes volver al paso anterior si crees que no estás listo.</p>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Si, realicé todo el proceso" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onProgressEnrollment()"></button>
          <div class="dialog__btnFloat">
            <p-button label="Volver al paso anterior" icon="pi pi-arrow-left" iconPos="left" [text]="true" [plain]="true" (onClick)="onReturnEnrollment()"></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
